// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../../../../../../schema/public';

import { gql } from '@apollo/client';
import { GameSessionFragmentDoc } from '../../../../../../../graphql/GameSessionFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StartGameSessionMutationVariables = Types.Exact<{
  lobbyUrl: Types.Scalars['String']['input'];
  language: Types.Scalars['String']['input'];
  isMobile?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  isFunMode?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  gameId: Types.Scalars['ID']['input'];
  currency?: Types.InputMaybe<Types.Scalars['String']['input']>;
  inGameCurrency?: Types.InputMaybe<Types.Scalars['String']['input']>;
  site: Types.Scalars['String']['input'];
  setIframePath?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type StartGameSessionMutation = { __typename?: 'Mutation', casinoStartGameSession?: { __typename?: 'CasinoStartGameSessionPayload', url?: string, errors?: Array<{ __typename?: 'CasinoError', code?: number, message?: string, params?: Array<{ __typename?: 'CasinoErrorParam', name?: string, value?: string }> }> } };


export const StartGameSessionMutationDocument = /*#__PURE__*/ gql`
    mutation StartGameSessionMutation($lobbyUrl: String!, $language: String!, $isMobile: Boolean, $isFunMode: Boolean, $gameId: ID!, $currency: String, $inGameCurrency: String, $site: String!, $setIframePath: String) {
  casinoStartGameSession(
    input: {site: $site, majorVersion: 2, language: $language, lobbyUrl: $lobbyUrl, demo: $isFunMode, mobile: $isMobile, gameId: $gameId, currency: $currency, integrationCurrency: $inGameCurrency, setIframePath: $setIframePath}
  ) {
    ...GameSessionFragment
  }
}
    ${GameSessionFragmentDoc}`;
export type StartGameSessionMutationMutationFn = Apollo.MutationFunction<StartGameSessionMutation, StartGameSessionMutationVariables>;
export function useStartGameSessionMutation(baseOptions?: Apollo.MutationHookOptions<StartGameSessionMutation, StartGameSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartGameSessionMutation, StartGameSessionMutationVariables>(StartGameSessionMutationDocument, options);
      }
export type StartGameSessionMutationHookResult = ReturnType<typeof useStartGameSessionMutation>;
export type StartGameSessionMutationMutationResult = Apollo.MutationResult<StartGameSessionMutation>;
export type StartGameSessionMutationMutationOptions = Apollo.BaseMutationOptions<StartGameSessionMutation, StartGameSessionMutationVariables>;